console.log("🧪 Script cargado correctamente");

// Esta función calcula el precio final en función del número de sérums y activos
function calcularPrecioTotal(serumCount, activeCount) {
  let precioFinal = 0;

  if (serumCount === 0) {
    return 0;
  }

  let activeDistribution = new Array(serumCount).fill(0);

  // Paso 1: asignar mínimo 1 activo por sérum (si hay)
  for (let i = 0; i < serumCount && activeCount > 0; i++) {
    activeDistribution[i]++;
    activeCount--;
  }

  // Paso 2: repartir segundos activos (hasta 2 activos)
  for (let i = 0; i < serumCount && activeCount > 0; i++) {
    if (activeDistribution[i] < 3) {
      activeDistribution[i]++;
      activeCount--;
    }
  }

  // Paso 3: repartir terceros activos (hasta 3 activos máximo)
  for (let i = 0; i < serumCount && activeCount > 0; i++) {
    if (activeDistribution[i] < 3) {
      activeDistribution[i]++;
      activeCount--;
    }
  }

  // Paso 4: calcular el precio en base a activos asignados
  activeDistribution.forEach(activesAssigned => {
    if (activesAssigned === 1) {
      precioFinal += 55;
    } else if (activesAssigned === 2) {
      precioFinal += 66;
    } else if (activesAssigned === 3) {
      precioFinal += 72;
    } else {
      // Sin activos asignados, igualmente cobra 55€
      precioFinal += 55;
    }
  });

  return precioFinal;
}

// Esta función actualiza el resumen mostrado en el drawer
function updateRoutineSummary(cart, shadowRoot) {
  let serumCount = 0;
  let activeCount = 0;
  let activesList = [];

  cart.items.forEach(item => {
    const title = item.product_title?.toLowerCase() || "";
    if (title.includes("serum")) {
      serumCount += item.quantity;
    } else {
      activeCount += item.quantity;
      activesList.push(item.product_title);
    }
  });

  const precioFinal = calcularPrecioTotal(serumCount, activeCount);

  // Crear el bloque visual
  let summary = shadowRoot.querySelector("#routine-summary");

  if (!summary) {
    summary = document.createElement("div");
    summary.id = "routine-summary";
    summary.style.padding = "16px";
    summary.style.borderTop = "1px solid #eee";
    summary.style.fontSize = "16px";
    summary.innerHTML = `
      <h4 style="margin-bottom: 8px;"> Tu fórmula personalizada</h4>
      <div id="routine-details" style="margin-bottom: 8px;"></div>
      <div id="routine-price" style="margin-top: 8px; font-weight: bold;"></div>
    `;
    const footer = shadowRoot.querySelector("footer");
    if (footer) footer.insertBefore(summary, footer.firstChild);
  }

  const details = summary.querySelector("#routine-details");
  const priceBox = summary.querySelector("#routine-price");

  details.innerHTML = `
    Sérums base: <strong>${serumCount}</strong><br>
    Activos añadidos: <strong>${activeCount}</strong> / ${serumCount * 3}<br><br>
    Activos elegidos: ${activesList.length > 0 ? activesList.join(", ") : "ninguno"}
  `;

  priceBox.innerHTML = `Precio total del pack: ${precioFinal.toFixed(2)} €`;
}

// Esta función observa cambios en el drawer
function observeDrawerUpdates(drawer, shadowRoot) {
  const observer = new MutationObserver(() => {
    console.log("👀 Cambio detectado en el drawer");
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => updateRoutineSummary(cart, shadowRoot));
  });

  observer.observe(shadowRoot, { childList: true, subtree: true });
  console.log("✅ MutationObserver activado dentro del shadowRoot");
}

// Esta función espera a que se abra el drawer para iniciar la observación
function waitForDrawerAndObserve() {
  const interval = setInterval(() => {
    const drawer = document.querySelector("cart-drawer[open]");
    if (drawer && drawer.shadowRoot) {
      console.log("✅ Drawer abierto y shadowRoot disponible");
      clearInterval(interval);

      // Primera carga
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => updateRoutineSummary(cart, drawer.shadowRoot));

      // Observamos futuros cambios
      observeDrawerUpdates(drawer, drawer.shadowRoot);
    }
  }, 300);
}

// Inicio del script al cargar la página
document.addEventListener("DOMContentLoaded", function () {
  console.log("🛒 DOM cargado");
  waitForDrawerAndObserve();
});